export default {
  'pages.common.save': 'Simpan',
  'pages.common.cancel': 'Batal',
  'pages.common.confirm': 'OK',
  'pages.common.ok': 'OK',
  'pages.common.delete': 'Hapus',
  'pages.common.edit': 'Edit',
  'pages.common.add': 'Tambah',
  'pages.common.append': 'Tambah',
  'pages.common.search': 'Cari',
  'pages.common.reset': 'Atur ulang',
  'pages.common.submit': 'Kirim',
  'pages.common.back': 'Kembali',
  'pages.common.close': 'Tutup',
  'pages.common.export': 'Ekspor',
  'pages.common.import': 'Impor',
  'pages.common.refresh': 'Segarkan',
  'pages.common.detail': 'Detail',
  'pages.common.copy': 'Salin',
  'pages.common.operation': 'Aksi',
  'pages.common.view': 'Lihat',
  'pages.common.download': 'Unduh',
  'pages.common.upload': 'Unggah',
  'pages.common.yes': 'Ya',
  'pages.common.no': 'Tidak',
  'pages.common.loading': 'Memuat…',
  'pages.common.more': 'Lainnya',
  'pages.common.all': 'Semua',
  'pages.common.createSuccess': 'Berhasil ditambahkan',
  'pages.common.saveSuccess': 'Berhasil disimpan',
  'pages.common.deleteSuccess': 'Berhasil dihapus',
  'pages.common.deleteFailed': 'Gagal menghapus',
  'pages.common.saveFailed': 'Gagal menyimpan',
  'pages.common.loadFailed': 'Gagal memuat',
  'pages.common.requiredField': 'Wajib diisi',
  'pages.common.selectedCount': '{count} item dipilih',
  'pages.common.clearSelection': 'Hapus pilihan',
  'pages.common.totalRecords': '{total} catatan',
  'pages.common.batchDeleteCount': 'Hapus batch ({count})',
  'pages.common.statusSuccess': 'Berhasil',
  'pages.common.statusFailed': 'Gagal',
  'pages.common.timeRangeStart': 'Waktu mulai',
  'pages.common.timeRangeEnd': 'Waktu selesai',
  'pages.common.unnamed': 'Tanpa nama',
  'pages.common.operationFailedRetry': 'Operasi gagal. Coba lagi.',
  'pages.common.batchDeleteSuccess': 'Hapus batch berhasil',
  'pages.common.batchDeleteFailed': 'Hapus batch gagal. Coba lagi.',
  'pages.common.nItemsFailed': '{count} item gagal',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
